import { CustomError } from './custom-error';
import { CodeError } from '../constant/text.constant';

export class PhoneNumberAlreadyExistsError extends CustomError {
  private static readonly CODE = CodeError.PHONE_NUMBER_ALREADY_EXISTS;

  constructor() {
    super(PhoneNumberAlreadyExistsError.CODE);
  }
}
